import React from "react";
import { Card, CardContent, Typography, Chip } from "@mui/material";

/**
 * A reusable card component for displaying show summary information
 * @param {Object} props
 * @param {string} props.label - The label text shown above the content
 * @param {React.ReactNode} props.content - The main content to display
 * @param {Object} props.chipProps - Optional props for rendering a chip instead of text content
 */
export default function ShowSummaryCard({ label, content, chipProps }) {
  return (
    <Card sx={{ minWidth: 270, flex: 1 }}>
      <CardContent>
        <Typography variant="overline">{label}</Typography>
        {chipProps ? (
          <Chip label={content} color={chipProps.color} size="small" />
        ) : // If content is a React element, clone and fix Typography nesting
        React.isValidElement(content) ? (
          React.cloneElement(
            content,
            {},
            React.Children.map(content.props.children, (child) =>
              React.isValidElement(child) && child.type === Typography
                ? React.cloneElement(child, {
                    component: child.props.component || "span",
                  })
                : child
            )
          )
        ) : (
          <Typography component="span">{content}</Typography>
        )}
      </CardContent>
    </Card>
  );
}
